import { render, staticRenderFns } from "./ResponsibleCorporateInput.vue?vue&type=template&id=0495e902&"
import script from "./ResponsibleCorporateInput.vue?vue&type=script&lang=js&"
export * from "./ResponsibleCorporateInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports